import { clearAuthState } from "./tokenUtils";
import { toast } from "react-toastify";

class AccountStatusChecker {
  constructor() {
    this.checkInterval = null;
    this.isChecking = false;
  }

  startChecking() {
    if (this.isChecking) return;
    this.isChecking = true;
    // Check every 15 minutes to avoid interfering with token refresh
    this.checkInterval = setInterval(() => {
      this.checkAccountStatus();
    }, 900000); // 15 minutes
  }

  stopChecking() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
    this.isChecking = false;
  }

  async checkAccountStatus() {
    const token = sessionStorage.getItem("authToken");
    const user = sessionStorage.getItem("user");

    if (!token || !user) {
      this.stopChecking();
      return;
    }

    try {
      const parsedUser = JSON.parse(user);
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL || "https://riskreport.almata.co.jp:3400/api"
        }/socket/status?userId=${parsedUser?.itSalesPartner?.id}&userType=itSalesPartner`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 404) {
        // Account deleted
        this.handleAccountDeleted();
      } else if (response.status === 403) {
        // Account expired or suspended
        this.handleAccountExpired();
      }
      // Don't handle 401 here - let the API client handle token refresh
    } catch (error) {
      console.error("Account status check failed:", error);
    }
  }

  handleAccountDeleted() {
    this.stopChecking();
    clearAuthState();

    // Show notification to user
    toast.error("Account deleted. You will be redirected to the login page.", {
      autoClose: 3000
    });

    // Delay redirect to allow toast to show
    setTimeout(() => {
      this.redirectToLogin();
    }, 3400);
  }

  handleAccountExpired() {
    this.stopChecking();
    clearAuthState();

    // Show notification to user
    toast.error(
      "Your account has been inactivated by the administrator.", {
      autoClose: 3000
    });
    
    // Delay redirect to allow toast to show
    setTimeout(() => {
      this.redirectToLogin();
    }, 3400);
  }

  redirectToLogin() {
    window.location.href = "/login";
  }
}

export const accountStatusChecker = new AccountStatusChecker();
